import { designToolMixin } from "../../../../lib/helpers";
const __script_base__ = {
  mixins: [designToolMixin],
  computed: {
    dataPath() {
      return this.getCompInstance().dataPath;
    }
  },
  methods: {
    open() {
      this.designer.openSettleComponentWindow({
        place: this.$el,
        compPath: this.compPath,
        dataPath: this.dataPath
      });
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.dataPath ? _c('div', {
    staticClass: "ucd-fullCoverDesignTool",
    on: {
      "mouseenter": _vm.open,
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "ucd-fullCoverDesignTool-content"
  }, [_vm._v("\n    点击打开备选列表\n  ")])]) : _vm._e();
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/FormUnsettledEditor/DesignTool.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);